export const pub = {
	home: async () => { const m = await import('@pages/home'); return { Component: m.Home }; },
	authFlow: async () => { const m = await import('@pages/authFlow'); return { Component: m.AuthFlow }; },
};

export const callbacks = {
	auth: async () => { const m = await import('@pages/callbacks/auth'); return { Component: m.AuthCallbackPage }; },
	consent: async () => { const m = await import('@pages/callbacks/consent'); return { Component: m.ConsentCallbackPage }; },
};

export const user = {
	profileUser: async () => { const m = await import('@pages/profileUser'); return { Component: m.ProfileUserPage }; },
	debitCardUser: async () => { const m = await import('@pages/debitCardUser'); return { Component: m.DebitCardUserPage }; },
	transactionsUser: async () => { const m = await import('@pages/transactionsUser'); return { Component: m.TransactionsUserPage }; },
};

export const company = {
	companyProfile: async () => { const m = await import('@pages/companyProfile'); return { Component: m.CompanyProfilePage }; },
	employees: async () => { const m = await import('@pages/employeesCompany'); return { Component: m.EmployeesCompanyPage }; },
	debitCards: async () => { const m = await import('@pages/debitCardsCompany'); return { Component: m.DebitCardsCompanyPage }; },
	benefits: async () => { const m = await import('@pages/benefitsCompany'); return { Component: m.BenefitsCompanyPage }; },
	topupOrders: async () => { const m = await import('@pages/topupOrdersCompany'); return { Component: m.TopupOrdersCompanyPage }; },
	topups: async () => { const m = await import('@pages/topupsCompany'); return { Component: m.TopupsCompanyPage }; },
};

